import type { TFspId } from "../shared/types"
import { getClientEnv } from "./client-env-init"

export function configureDomain(domain: string) {
  const func = "configureDomain"

  // Based on the domain, return a country and delivery service configuration object
  // -------------------------------------------------------------------------------
  const staticDomainToConfiguration: Record<string, { fspId: TFspId }> = {
    localhost: {
      fspId: getClientEnv().VITE_FOOD_SERVICE_PROVIDER,
    },
    // localhost: { country: "denmark", fspId: "tiffin" },

    "restaurant.maul.is": { fspId: "maul" },

    "kitchen.tiffin.dk": {
      fspId: "tiffin",
    },

    "kitchen-web.vercel.app": {
      fspId: "tiffin",
    },
  }

  // Due the Vercel providing dynamic url for their preview domains we have to handle it separately
  const vercelPreviewDomainToConfiguration = (dynamicDomain: string): { fspId: TFspId } => {
    if (dynamicDomain.endsWith("maul.vercel.app")) {
      return { fspId: "maul" }
    }

    throw new Error("Unknown domain, cannot configure correct fsp id")
  }

  const domainConfig =
    staticDomainToConfiguration[domain] ?? vercelPreviewDomainToConfiguration(domain)
  console.log("🌍", { func }, "Based on site domain initialized domain configuration", {
    domainConfig,
  })

  if (!domainConfig) {
    const message = `No domain configuration exists for site domain ${domain}`
    console.log("💥", { func }, message)
    throw new Error(message)
  }
  // -------------------------------------------------------------------------------

  return domainConfig
}
